"use client";

import React from "react";
import { Phone, ArrowRight, ShieldCheck, HardHat, Award } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const serviceHighlights = [{
  label: "Commercial & developments",
  key: "commercial"
}, {
  label: "Residential & renovations",
  key: "residential"
}, {
  label: "Roofing & temporary covers",
  key: "roofing"
}, {
  label: "Specialist & difficult access",
  key: "specialist"
}];
const credentials = [{
  title: "NASC Accredited",
  icon: ShieldCheck
}, {
  title: "CHAS Accredited",
  icon: Award
}, {
  title: "20+ Years Experience",
  icon: HardHat
}];
export default function HeroWoking() {
  return <section id="herowoking" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground py-20 lg:py-28">
      {/* Background Decorative Pattern & Gradients */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary),transparent_50%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,currentColor_1px,transparent_1px),linear-gradient(to_bottom,currentColor_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {/* Main Copy & CTAs */}
          <div className="lg:col-span-7 flex flex-col items-start text-left">
            <div className="inline-flex items-center gap-2 mb-6">
              <Badge variant="outline" className="border-secondary-foreground/20 text-secondary-foreground text-xs uppercase tracking-wider px-3 py-1 font-semibold">
                Surrey & Home Counties
              </Badge>
              <span className="text-xs text-secondary-foreground/70 font-medium">
                NASC & CHAS Accredited
              </span>
            </div>

            <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-secondary-foreground leading-tight sm:leading-none">
              Scaffolding in Woking
            </h2>

            <p className="mt-6 text-lg sm:text-xl text-secondary-foreground/80 max-w-2xl leading-relaxed font-sans">
              Reliable scaffolding across commercial developments, residential properties, roofing projects, and specialist access sites in Woking and Surrey. Planned accurately, erected safely, and managed by experienced professionals.
            </p>

            {/* Quick Service Tags */}
            <div className="mt-6 flex flex-wrap gap-2">
              {serviceHighlights.map((item, i) => <span key={item.key} data-index={i} className="inline-flex items-center text-xs font-medium px-3 py-1 rounded-md bg-secondary-foreground/10 text-secondary-foreground/90 border border-secondary-foreground/15">
                  {item.label}
                </span>)}
            </div>

            {/* Actions */}
            <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-7">
                <Link to="/ContactRequestQuotePage" className="inline-flex items-center gap-2">
                  Request a quote
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/30 text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground font-semibold px-7">
                <a href="tel:01344929900" className="inline-flex items-center gap-2 text-secondary-foreground hover:text-secondary-foreground">
                  <Phone className="size-4 text-secondary-foreground" />
                  <span className="text-secondary-foreground">Call 01344 929900</span>
                </a>
              </Button>
            </div>
          </div>

          {/* Side Feature / Summary Card */}
          <div className="lg:col-span-5">
            <div className="rounded-xl border border-secondary-foreground/15 bg-secondary-foreground/5 p-6 sm:p-8 backdrop-blur-xs">
              <h2 className="text-xl font-semibold text-secondary-foreground mb-4">
                Operational standards you can count on
              </h2>
              <p className="text-sm text-secondary-foreground/75 leading-relaxed mb-6 font-sans">
                BMF Scaffolding provides fully compliant access solutions with strict safety supervision, clear handover documentation, and direct accountability.
              </p>

              <div className="space-y-4 pt-2">
                {credentials.map((cred, index) => {
                const Icon = cred.icon;
                return <div key={cred.title} data-index={index} className="flex items-center gap-3.5 rounded-lg border border-secondary-foreground/10 bg-secondary/80 p-3.5 text-sm">
                      <div className="flex size-9 shrink-0 items-center justify-center rounded-md bg-primary text-primary-foreground">
                        <Icon className="size-5" />
                      </div>
                      <div className="font-medium text-secondary-foreground">
                        {cred.title}
                      </div>
                    </div>;
              })}
              </div>

              <div className="mt-6 pt-6 border-t border-secondary-foreground/10 flex items-center justify-between text-xs text-secondary-foreground/70">
                <span>Free site surveys in Woking</span>
                <span className="font-medium text-secondary-foreground">Fast turnaround</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}